import { createContext, useContext } from "react";

/**
 * The share surface's context, kept import-free: V2CardHeader (Dashboard ui)
 * reads it, and must not pull the Reports state graph in with it.
 * Provider: ./ReportShareScope.tsx.
 */
export interface ReportShareScopeValue {
  getSummary: () => string[];
  getPreparedBy: () => string | null;
}

export const ReportShareScopeContext = createContext<ReportShareScopeValue | null>(null);

/** Null outside the Reports page, or for a role whose report export is denied. */
export function useReportShareScope(): ReportShareScopeValue | null {
  return useContext(ReportShareScopeContext);
}

/** `data-report-share-root`: where "Share this view" looks for the tab on screen. */
export const REPORT_SHARE_ROOT_ATTR = "data-report-share-root";

/** Anything carrying this attribute is left out of the PDF (share buttons, menus). */
export const PDF_HIDE_ATTR = "data-pdf-hide";

/** A block sized to the VIEWPORT on screen (it fills the page, its table
 *  scrolls inside) that takes its CONTENT's height in the PDF, so every row
 *  opened up by the capture is inside the captured box. */
export const PDF_NATURAL_ATTR = "data-pdf-natural";

/** Set by V2Card on its root — the element one card's Share captures. */
export const V2_CARD_ATTR = "data-v2-card";
